import {useQuery} from '@apollo/client';
import { GET_PARAMETERS } from '../../Queries/parameters';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';

const UseGetAllParameters = (lang) => {

    const [variables,SetVariables] = useState({
        searchText:"",
        lang,
        limit:40,
        offset:0
    });
    const client = useApolloClient();
    const {t} = useTranslation();
    const [content,SetContent] = useState(null);
    const [selectedParameterIDs,SetSelectedParameterIDs] = useState([]);

    const {data,loading,error,fetchMore,refetch} = useQuery(GET_PARAMETERS,{
        variables,
        fetchPolicy:"network-only",
        skip:(variables.lang == "" ? true : false)
    })

    const FetchMore = (offset) => {

        fetchMore({
            variables: {
                offset: offset
            },
            updateQuery: (prev, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prev;
                return Object.assign({}, prev, {
                    AllParameters: [...prev.AllParameters, ...fetchMoreResult.AllParameters]
                });
            }
        });
    }

    const GoToPage = (page) => {

        SetVariables((prevValue) => {

            var newOffset = (page - 1) * prevValue.limit;
            if(newOffset == prevValue.offset)
                refetch();

            return {...prevValue,offset:newOffset}

        })
    }

    useEffect(() => {

        if(lang)
            SetVariables({...variables,lang:lang})

    },[lang])

    useEffect(() => {

        if(data)
        {
            const contentData = GetContentData(data.AllParameters);
            SetContent(contentData);
        }

    },[data])

    const headerData = [
        {
            value: t("ParameterName"),
            className:"flex-1"
        }
    ];

    const GetContentData = (data) => {

        var contentData = [];

        for(let val of data)
        {
            var cData = {
                data:[
                    {
                        value:val.name,
                        className:"flex-1"
                    }
                ],
            }

            cData.rowID       = val.parameterID;
            cData.allowEdit   = val.allowEdit;
            cData.allowDelete = val.allowDelete;
            cData.selected    = false;

            contentData.push(cData)
        }
        return contentData;
    }

    const SelectRow = (e,parameterID) => {

        var checked = e.target.checked;
        var newSelectedParameterIDs = [...selectedParameterIDs];
        const newList = SelectParameterID(content,parameterID,checked,newSelectedParameterIDs)

        SetContent(newList);
        SetSelectedParameterIDs(newSelectedParameterIDs);
    }

    const SelectAll = (e) => {

        var checked = e.target.checked;
        var newSelectedParameterIDs = [];
        const newList = SelectParameterID(content,"all",checked,newSelectedParameterIDs)

        SetSelectedParameterIDs(newSelectedParameterIDs);
        SetContent(newList);
    }

    const SelectParameterID = (list,parameterID,checked,selectedParameterIDs) => {

        const newList = [...list];
        for(let i = 0; i < newList.length; i++)
        {
            if(newList[i].allowDelete == undefined || newList[i].allowDelete == true)
            {
                if(parameterID == newList[i].rowID || parameterID === "all")
                {
                    newList[i] = {...newList[i],selected:checked}
                    if(checked)
                        selectedParameterIDs.push(newList[i].rowID);
                    else
                    {
                        for(let j = 0; j < selectedParameterIDs.length; j++)
                        {
                            if(selectedParameterIDs[j] == newList[i].rowID)
                                selectedParameterIDs.splice(j,1);  
                        } 
                    }
                }

                if(newList[i].subData)
                    newList[i] = {...newList[i],subData:SelectParameterID(newList[i].subData,parameterID,checked,selectedParameterIDs)}
            }
        }

        return newList;
    }

    const UpdateListAfterAddEdit = (selectedParameterID,data) => {
        
        const { AllParameters } = client.readQuery({ query: GET_PARAMETERS, variables });
        var newArray = [...AllParameters];

        if(selectedParameterID && selectedParameterID != 0)
        {
            for(let i in newArray)
            {
                if(newArray[i].parameterID == data.parameterID)
                {
                    newArray[i] = {...newArray[i],name: data.name};
                }
            } 
        }
        else
            newArray.unshift({
                parameterID: data.parameterID,
                name: data.name,
            })
        
        client.writeQuery({ 
            query:GET_PARAMETERS,
            variables,
            data:{
                AllParameters: newArray
            } 
        });
    }

    const UpdateListAfterDelete = (IDs) => {

        var response = IDs.split(",");
        
        const { AllParameters } = client.readQuery({ query: GET_PARAMETERS, variables });
        var newArray = [...AllParameters];
        
        for(let id of response)
        {
            for(let i in newArray)
            {
                if(newArray[i].parameterID == id)
                    newArray.splice(i,1);
            } 
        } 
        
        client.writeQuery({ 
            query:GET_PARAMETERS,
            variables,
            data:{
                AllParameters: newArray
            } 
        });
    }

    const Filter = (filterData) => {

        var newVariables = {...variables};
        var updated = false;
       
        if(filterData.searchText != "" || (filterData.searchText == "" && newVariables.searchText != ""))
        {
            newVariables.searchText = filterData.searchText;
            updated = true;
        }

        if(updated)
            SetVariables(newVariables)

    }

    return{
        content,
        totalContentLength: data && data.AllParametersCount || 0,
        paggingOffset: variables.offset,
        paggingLimit: variables.limit,
        headerData,
        loading,
        error,
        selectedParameterIDs,
        GoToPage,
        FetchMore,
        SelectRow,
        SelectAll,
        UpdateListAfterAddEdit,
        UpdateListAfterDelete,
        Filter
    }
}

export default UseGetAllParameters;